//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import productSuggestionOverlayTemplate from '@legacy-components/intelligent-product-tagging/product-suggestion-overlay.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.component('productSuggestionOverlay', {
    bindings: {
      suggestionBoxClicked: '&',
      universalItemId: '@',
    },
    template: productSuggestionOverlayTemplate,
    controller: [
      '$rootScope',
      '$timeout',
      'AssistedProductTaggingService',
      'ProductTaggingService',
      'TrackingService',
      'UniversalImageActionsHelpers',
      'UniversalImageActionsService',
      function(
                $rootScope,
                $timeout,
                AssistedProductTaggingService,
                ProductTaggingService,
                TrackingService,
                UniversalImageActionsHelpers,
                UniversalImageActionsService,
            ) {
        const self = this;
        let existingProducts;
        let allSuggestionBoundingBoxes;
        const BOX_COLLAPSE_ANIMATION_DURATION_MILLISECONDS = 350;
        const TRACKING_CATEGORY = UniversalImageActionsHelpers.getTrackingCategory(UniversalImageActionsService.getCurrentPage());

        const findCurrentBoundingBoxes = function() {
          self.suggestionBoundingBoxes = _(allSuggestionBoundingBoxes).reject(box => box.selectedProduct && box.selectedProduct.productStyleId &&
                            _.chain(existingProducts).pluck('productStyleId').contains(box.selectedProduct.productStyleId).value());
        };

        $rootScope.$on('uia:products-changed', ($event, newProducts) => {
          existingProducts = newProducts;
          findCurrentBoundingBoxes();
        });

        self.onSuggestionBoxClicked = function(boxId, event) {
          self.selectedBoxId = boxId;
          const cachedBoundingBox = AssistedProductTaggingService.getCachedBoundingBox(self.universalItemId, boxId);
          const productCategory = _(cachedBoundingBox).safeGet('keywords.0');

          TrackingService.recordEvent(TRACKING_CATEGORY, TrackingService.ACTION_ADD_PRODUCT_BOUNDING_BOX, productCategory);
          $timeout(() => {
            self.suggestionBoxClicked({
              boxId,
              coordinates: cachedBoundingBox.coordinates,
              event,
            });
          }, BOX_COLLAPSE_ANIMATION_DURATION_MILLISECONDS);
        };

        self.shouldShowBoundingBox = function(suggestion) {
          return !self.selectedBoxId || self.selectedBoxId === suggestion.boxId;
        };

        self.$onInit = function() {
          UniversalImageActionsService.getItemMetadataAsync().then(() => {
            existingProducts = ProductTaggingService.getProducts();
            AssistedProductTaggingService.getProductRelevancyDataSubject(self.universalItemId).subscribe((newBoundingBoxes) => {
              allSuggestionBoundingBoxes = _(newBoundingBoxes.relevancyData.boundingBoxes).sortBy(box =>
                                // sort by reverse size so smaller boxes render on top of larger boxes in HTML
                                 box.coordinates.width * box.coordinates.height * -1);

              findCurrentBoundingBoxes();
            });
          });
        };
      },
    ],
  });
})();
